// extracted by mini-css-extract-plugin
export default {"body-1":"ucD12GWwT8jTkZN6yAJp","body-2":"OjsYPY_rAZig4AbwDSUs","body-3":"Rm9T4bBMWHfTJo4KfMiu","ant-typography":"zIUIh70Jj_c4JFdvP2VJ","text":"onna1sxzgQZfrhZ38Zd9"};